import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpErrorResponse } from '@angular/common/http';
import { environment } from '../../../environments/environment';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class RevisionAcpODSService {



  token: string = '';
  baseUrl = environment.apiEndpoint;

  constructor(private http: HttpClient) {
    this.token = environment.token;
  }

  private header(accessToken: string) {
    var headers = new HttpHeaders({
      'Content-Type': 'application/json',
      "Accept": "application/json",
      "Authorization": "Bearer " + accessToken
    });
    return headers;
  }
  
  getAcpByTechoId(id: string): Observable<any> {
    return this.http.get(this.baseUrl + 'acpByTechoId/' + id, { headers: this.header(this.token) });
  }
  
  getListODS(): Observable<any> {
    return this.http.get(this.baseUrl + 'listODS', { headers: this.header(this.token) });
  }  

  getListPSDI(): Observable<any> {
    return this.http.get(this.baseUrl + 'listPSDI', { headers: this.header(this.token) });
  }
  
  postRevisionAcp(data: any): Observable<any> {
    let bodyString = JSON.stringify(data);
    return this.http.post(this.baseUrl + 'revisionAcp', bodyString, { headers: this.header(this.token) });
  }

  deleteTareaODS(id: number): Observable<any> {
    return this.http.delete(this.baseUrl + 'deleteRevisionAcp/' + id, { headers: this.header(this.token) });
  }
}
